
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const qs = require('qs');

const state = {
	organization: {
		picture: '',
	},
	overview: {},
	lastWeek: {},
};
const actions = {
	getAnalytics: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/dashboard?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setAnalytics', response.data, { root: true });
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data);
				commit('statusCheck', error.response.status);
			});
	}),
	getLastWeekAnalytics: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/dashboard?api_key=${payload.apiKey}&range=7`)
			.then((response) => {
				resolve(response);
				commit('setLastWeekAnalytics', response.data, { root: true });
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data);
				commit('statusCheck', error.response.status);
			});
	}),
};

const mutations = {
	setAnalytics: (state, payload) => {
		state.overview = payload;
	},
	setLastWeekAnalytics: (state, payload) => {
		state.lastWeek = payload;
	},
};


export default {
	state,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/metrics/store.js